import cs from 'classnames';
import moment from 'moment';

import { ia } from 'lib/helpers/utility';

import { createQueryFilters } from 'components/shared/AgTablePage/lib/createQueryFilters';
import Popover from 'components/shared/Popovers/Popover/Popover';

import TreatmentPlanStatus from '../TreatmentPlanStatus';

export const treatmentPlanCols = ({
  setTreatmentPlanToDelete = () => {},
  setShowTPModal = () => {},
  setSelectedTreatmentPlan = () => {},
  showCheckboxes = false
}) => {
  const cols = [
    {
      field: 'treatment_frequency_date.startDate',
      headerName: 'Start Date'
    },
    {
      field: 'treatment_frequency_date.endDate',
      headerName: 'End Date (Review Date)',
      cellRenderer: ({ value, data }) => {
        const endDateMoment = moment(data.treatment_frequency_date?.endDate, 'MM/DD/YYYY');
        const currentDate = moment();
        const isExpired = endDateMoment.isBefore(currentDate, 'day');

        return <p className={cs(isExpired && '!text-danger-500')}> {value}</p> || 'N/A';
      }
    },
    {
      field: 'icd10',
      headerName: 'ICD Codes',
      valueFormatter: ({ value: icd10 }) =>
        ia(icd10) ? icd10.map((i) => i?.value).join(', ') : '-'
    },
    {
      field: 'cpt_codes',
      headerName: 'CPT Codes',
      valueFormatter: ({ value }) =>
        ia(value) ? value?.map((i) => i?.procedure_code).join(', ') : 'N/A'
    },
    {
      field: 'createdBy.fullName',
      headerName: 'Created By',
      valueFormatter: ({ value }) => (!!value ? value : 'N/A')
    },
    {
      field: 'status',
      headerName: 'Status',
      cellClass: 'no-border',
      cellRenderer: (params) => {
        if (params.node.group || !params?.data) {
          return null;
        }
        return (
          <div className="flex h-full items-center justify-center">
            <TreatmentPlanStatus
              signers={params?.data?.document_sign}
              classNames="flex min-w-[80px] justify-center items-center"
            />
          </div>
        );
      },
      resizable: false
    },
    {
      field: 'actions',
      headerName: 'Actions',
      cellRenderer: (params) => {
        return (
          <div
            className="actions-column flex h-full w-full items-center justify-center"
            onClick={(e) => e.stopPropagation()}>
            <Popover
              options={[
                {
                  icon: 'document-preview-mono',
                  label: 'Preview',
                  onClick: () => {
                    setSelectedTreatmentPlan(params?.data);
                    setShowTPModal({ open: true, loadView: 'preview' });
                  }
                },
                {
                  icon: 'edit-2-mono',
                  label: 'Edit',
                  onClick: () => {
                    setSelectedTreatmentPlan(params?.data);
                    setShowTPModal({ open: true, loadView: 'edit' });
                  }
                },
                {
                  icon: 'trash-mono',
                  label: 'Delete',
                  onClick: () => {
                    setTreatmentPlanToDelete(params?.data?.id);
                  }
                }
              ]}
              className="flex h-full w-full items-center justify-center"
              position="left"
              isFixed
              icon="context-menu-horizontal"
              isBorder={false}
            />
          </div>
        );
      },
      maxWidth: 88,
      minWidth: 36,
      resizable: false,
      sortable: false,
      pinned: 'right'
    }
  ];

  if (showCheckboxes) {
    cols.unshift({
      field: 'checkbox_selection',
      headerName: '',
      maxWidth: 50,
      headerCheckboxSelection: showCheckboxes,
      checkboxSelection: showCheckboxes
    });
  }
  return cols;
};

export const getTreatmentPlanParams = ({ fromPracticeIQueue, filters, limit, page, sort, id }) => {
  return fromPracticeIQueue
    ? {
        filters: createQueryFilters(filters),
        limit,
        page,
        sort,
        withRelations: { createdBy: true, document_sign: true },
        withCount: true
      }
    : { patientId: id, withRelations: { createdBy: true, document_sign: true } };
};

export const SUCCESS_MESSAGE_TP_DELETE = ({ itemsAffected }) => {
  return itemsAffected > 1
    ? 'Treatment plans deleted successfully'
    : 'Treatment plan deleted successfully';
};

export const ERROR_MESSAGE_TP_DELETE = ({ itemsAffected }) => {
  return itemsAffected > 1 ? 'Error deleting treatment plans' : 'Failed to delete treatment plan';
};
